import chainConfigJson from './chainConfig.json';

export const defaultChainConfig = chainConfigJson;

export const defaultConsensusKey =
  '0xa449b1ffee0e2205fa924c6740cc48b3b473aa28587df6dab12abc245d1f5298';
